import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ServiceReminders } from '../_models/service-reminders';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServiceReminderService {
  private serviceReminderSubject = new BehaviorSubject<ServiceReminders[]>([]);
  public serviceReminders$ = this.serviceReminderSubject.asObservable();


  constructor(
    private api: ApiService,
  ) { }

  getReminders(page: number, rows: number, filter?: string | null) {
    let params = new HttpParams()
      .set('skip', (page - 1) * rows)
      .set('limit', rows);
    if (filter) {
      params = params.set('filter', filter);
    }
    return this.api.getAPI<ServiceReminders[]>('servicereminders', params)
  }

  addReminder(newReminder: any) {
    return this.api.postAPI<ServiceReminders>('servicereminders', newReminder);
  }

  updateReminder(reminder: any, id: number) {
    return this.api.updateAPI<ServiceReminders>(`servicereminders`, id, reminder);
  }

  deleteReminder(id: number) {
    return this.api.deleteAPI<any>('servicereminders', id);
  }

  updateReminders(reminder: ServiceReminders[]) {
    this.serviceReminderSubject.next(reminder);
  }

  signOffReminder(reminderId: number) {
    return this.api.updateAPI<any>(`servicereminders/signoff`, reminderId, {});
  }
}
